module.exports = __webpack_public_path__ + "static/gallery11-1ae11f7ef2113c2296d4245b9bd62b5e.jpg";